

import './App.css';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import ProtectedRoute from './components/protectedRoute/ProtectedRoute';
import Login from './components/login/Login';
import Dashboard from './components/dashboard/Dashboard';
import Sidebar from './components/sideBar/sidebar';
import LoanBenefits from './components/benefits/LoanBenefits';
import AddLoanBenefits from './components/benefits/AddLoanBenefits';
import EditLoanBenefits from './components/benefits/EditLoanBenefits';
import ListHomeFeatures from './components/home-features/HomeFeatures';
import AddHomeFeature from './components/home-features/AddHomeFeatures';
import EditHomeFeature from './components/home-features/EditHomeFeatures';
import LoanFeatures from './components/features/LoanFeatures';
import AddLoanFeature from './components/features/AddLoanFeatures';
import EditLoanFeature from './components/features/EditLoanFeatures';
import LoanCriteriaList from './components/criteria/LoanCriteria';
import AddLoanCriteria from './components/criteria/AddLoanCriteria';
import EditLoanCriteria from './components/criteria/EditLoanCriteria';
import LoanEffortlessList from './components/effortless/LoanEffortless';
import AddLoanEffortless from './components/effortless/AddLoanEffortless';
import EditLoanEffortless from './components/effortless/EditLoanEffortless';
import LoanImagesList from './components/Images/LoanImages';
import AddLoanImage from './components/Images/AddLoanImages';
import EditLoanImage from './components/Images/EditLoanImages';
import TalkToExpartTable from './components/form-table/TalkToExpartTable';
import UserDetailsTable from './components/form-table/UserDetailsTable';
import CareerFormTable from './components/form-table/CareerFormTable';
import OfferFormTable from './components/form-table/OfferFormTable';
import EditLoanDetails from './components/loan-details/EditLoanDetails';
import LoanDetailView from './components/loan-details/LoanDetails';
import LoanDetailsList from './components/loan-details/LoanDetails';
import LoanStepList from './components/loan-step/LoanStep';
import AddLoanStep from './components/loan-step/AddLoanStep';
import EditLoanStep from './components/loan-step/EditLoanStep';
import DisclaimerList from './components/disclaimer/Disclaimer';
import EditDisclaimer from './components/disclaimer/EditDisclaimer';
import PrivacyPolicyList from './components/privacy-policy/PrivacyPolicy';
import EditPrivacyPolicy from './components/privacy-policy/EditPrivacyPolicy';
import TermsConditionList from './components/terms-condition/TermsCondition';
import EditTermsCondition from './components/terms-condition/EditTermsCondition';
import LoanFormEffortless from './components/form-effortless/FormEffortless';
import AddLoanFormEffortless from './components/form-effortless/AddFormEffortless';
import EditLoanFormEffortless from './components/form-effortless/EditFormEffortless';
import MissionList from './components/mission/Mission';
import AddMission from './components/mission/AddMission';
import EditMission from './components/mission/EditMission';
import DSAFormTable from './components/form-table/DSAFormTable';
import BusinessPartnerFormTable from './components/form-table/BusinessPartnerTable';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        
        <Routes>
          <Route path='/' exact element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute><Sidebar/>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path='/loan-step' exact element={<ProtectedRoute><Sidebar/><LoanStepList /></ProtectedRoute>} />
          <Route path='/add-loan-step' exact element={<ProtectedRoute><Sidebar/><AddLoanStep /></ProtectedRoute>} />
          <Route path='/edit-loan-step/:id' exact element={<ProtectedRoute><Sidebar/><EditLoanStep /></ProtectedRoute>} />
          
          <Route path='/loan-benefits' exact element={<ProtectedRoute><Sidebar/><LoanBenefits /></ProtectedRoute>} />
          <Route path='/add-loan-benefits' exact element={<ProtectedRoute><Sidebar/><AddLoanBenefits /></ProtectedRoute>} />
          <Route path='/edit-loan-benefits/:id' exact element={<ProtectedRoute><Sidebar/><EditLoanBenefits /></ProtectedRoute>} />
          <Route path='/home-features' exact element={<ProtectedRoute><Sidebar/><ListHomeFeatures /></ProtectedRoute>} />
          <Route path='/add-home-features' exact element={<ProtectedRoute><Sidebar/><AddHomeFeature /></ProtectedRoute>} />
          <Route path='/edit-home-features/:id' exact element={<ProtectedRoute><Sidebar/><EditHomeFeature /></ProtectedRoute>} />
          <Route path='/loan-features' exact element={<ProtectedRoute><Sidebar/><LoanFeatures /></ProtectedRoute>} />
          <Route path='/add-loan-features' exact element={<ProtectedRoute><Sidebar/><AddLoanFeature /></ProtectedRoute>} />
          <Route path='/edit-loan-features/:id' exact element={<ProtectedRoute><Sidebar/><EditLoanFeature /></ProtectedRoute>} />
          <Route path='/loan-criteria' exact element={<ProtectedRoute><Sidebar/><LoanCriteriaList /></ProtectedRoute>} />
          <Route path='/add-loan-criteria' exact element={<ProtectedRoute><Sidebar/><AddLoanCriteria /></ProtectedRoute>} />
          <Route path='/edit-loan-criteria/:id' exact element={<ProtectedRoute><Sidebar/><EditLoanCriteria /></ProtectedRoute>} />
          <Route path='/loan-effortless' exact element={<ProtectedRoute><Sidebar/><LoanEffortlessList /></ProtectedRoute>} />
          <Route path='/add-loan-effortless' exact element={<ProtectedRoute><Sidebar/><AddLoanEffortless /></ProtectedRoute>} />
          <Route path='/edit-loan-effortless/:id' exact element={<ProtectedRoute><Sidebar/><EditLoanEffortless /></ProtectedRoute>} />
          <Route path='/loan-image' exact element={<ProtectedRoute><Sidebar/><LoanImagesList /></ProtectedRoute>} />
          <Route path='/add-loan-image' exact element={<ProtectedRoute><Sidebar/><AddLoanImage /></ProtectedRoute>} />
          <Route path='/edit-loan-image/:id' exact element={<ProtectedRoute><Sidebar/><EditLoanImage /></ProtectedRoute>} />
          <Route path='/talk-to-expart' exact element={<ProtectedRoute><Sidebar/><TalkToExpartTable /></ProtectedRoute>} />
          <Route path='/user-details' exact element={<ProtectedRoute><Sidebar/><UserDetailsTable /></ProtectedRoute>} />
          <Route path='/career-form' exact element={<ProtectedRoute><Sidebar/><CareerFormTable /></ProtectedRoute>} />
          <Route path='/offer-form' exact element={<ProtectedRoute><Sidebar/><OfferFormTable /></ProtectedRoute>} />
          <Route path='/loan-details' exact element={<ProtectedRoute><Sidebar/><LoanDetailsList /></ProtectedRoute>} />
          {/* <Route path='/loan-details-view/:id' exact element={<ProtectedRoute><Sidebar/><LoanDetailView /></ProtectedRoute>} /> */}
          <Route path='/edit-loan-details/:id' exact element={<ProtectedRoute><Sidebar/><EditLoanDetails /></ProtectedRoute>} />
          <Route path='/disclaimer' exact element={<ProtectedRoute><Sidebar/><DisclaimerList /></ProtectedRoute>} />
          <Route path='/edit-disclaimer/:id' exact element={<ProtectedRoute><Sidebar/><EditDisclaimer /></ProtectedRoute>} />
          <Route path='/privacy-policy' exact element={<ProtectedRoute><Sidebar/><PrivacyPolicyList /></ProtectedRoute>} />
          <Route path='/edit-privacy-policy/:id' exact element={<ProtectedRoute><Sidebar/><EditPrivacyPolicy /></ProtectedRoute>} />
          <Route path='/terms-condition' exact element={<ProtectedRoute><Sidebar/><TermsConditionList /></ProtectedRoute>} />
          <Route path='/edit-terms-condition/:id' exact element={<ProtectedRoute><Sidebar/><EditTermsCondition /></ProtectedRoute>} />

          <Route path='/loan-form-effortless' exact element={<ProtectedRoute><Sidebar/><LoanFormEffortless /></ProtectedRoute>} />
          <Route path='/add-loan-form-effortless' exact element={<ProtectedRoute><Sidebar/><AddLoanFormEffortless /></ProtectedRoute>} />
          <Route path='/edit-loan-form-effortless/:id' exact element={<ProtectedRoute><Sidebar/><EditLoanFormEffortless /></ProtectedRoute>} />

          <Route path='/mission' exact element={<ProtectedRoute><Sidebar/><MissionList /></ProtectedRoute>} />
          <Route path='/add-mission' exact element={<ProtectedRoute><Sidebar/><AddMission /></ProtectedRoute>} />
          <Route path='/edit-mission/:id' exact element={<ProtectedRoute><Sidebar/><EditMission /></ProtectedRoute>} />
          <Route path='/dsa-form' exact element={<ProtectedRoute><Sidebar/><DSAFormTable /></ProtectedRoute>} />
          <Route path='/business-partner' exact element={<ProtectedRoute><Sidebar/><BusinessPartnerFormTable /></ProtectedRoute>} />
          

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
